import { useTheme } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PlayStationSVG } from '../../components/icons/PlayStationIcon'
import { PlatformSelectBox } from '../../components/PlatformSelectBox/PlatformSelectBox'
import { useConfig } from '../../providers/envConfig'
import { EnvConfig } from '../../providers/envConfig/envConfig'
import { colors } from '../../theme/options'
import { FirstPartyPlatformType } from '../../types/Account'
import { getCurrentLanguageFromUrl } from '../../utils/language.ts'

/**
 * Builds the PlayStation Network login URL based on the provided configuration.
 * @param config - The configuration object containing PSN OAuth details.
 * @return {URL} - The constructed OAuth 2.0 authorization URL for PSN login.
 */
export function buildPlayStationLoginURL(config: EnvConfig['playStation']): URL {
  const { authorizationURL, clientId, callbackUri, scope } = config
  const url = new URL(authorizationURL)
  url.searchParams.set('client_id', clientId)
  url.searchParams.set('response_type', 'code')
  url.searchParams.set('redirect_uri', callbackUri)
  url.searchParams.set('scope', scope)
  url.searchParams.set('request_locale', getCurrentLanguageFromUrl()) // Default to English, can be changed based on user preference
  return url
}

const PlayStationPlatformSelectBox: FC = () => {
  const envConfig = useConfig()
  const theme = useTheme()
  const { t } = useTranslation('vpc', { keyPrefix: 'login' })

  const handlePlayStationLogin = () => {
    window.location.href = buildPlayStationLoginURL(envConfig.playStation).toString()
  }

  return (
    <PlatformSelectBox
      data-testid="platform-select-box-playstation"
      color={colors.playstation}
      title={t(`${FirstPartyPlatformType.PLAYSTATIONNETWORK.toLowerCase()}.name`)}
      icon={<PlayStationSVG sx={{ color: theme.palette.common.white, fontSize: '2.5rem' }} />}
      onClick={handlePlayStationLogin}
    />
  )
}

export default PlayStationPlatformSelectBox
